import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import FormRegisterClub from '../../../../components/Forms/FormRegisterClub/FormRegisterClub'
import Typography from '../../../../components/Typography/Typography'

import './BecomeMemberHeader.scss'

const UserProfileHeader = ({ registerClub, loading }) => {
    const intl = useIntl()
    const [showModal, setShowModal] = useState(false)

    return (
        <Container fluid className="become-member-header">
            <div className="become-member-header--img position-absolute top-0 start-0 end-0">
                <img src={'images/backgrounds/astronaut-profile.png'} alt={'astronaut-profile'} />
            </div>
            <div className="become-member-header--title position-relative d-flex flex-column">
                <Typography variant={'hero'}>
                    {intl.formatMessage({ id: 'userProfile.title' }, { br: <br /> })}
                </Typography>
                <Typography variant={'p'}>{intl.formatMessage({ id: 'userProfile.description' })}</Typography>
                <div>
                    <ButtonCinestar variant={'primary-v1'} onClick={() => setShowModal(true)}>
                        {intl.formatMessage({ id: 'userProfile.buttonOrder' })}
                    </ButtonCinestar>
                    <FormRegisterClub
                        show={showModal}
                        handleSubmit={registerClub}
                        onHide={() => setShowModal(false)}
                        loading={loading}
                    />
                </div>
            </div>
        </Container>
    )
}

export default UserProfileHeader
